__turbopack_context__.v({
  "container": "index-module-scss-module__nTqgSG__container",
  "content": "index-module-scss-module__nTqgSG__content",
  "count": "index-module-scss-module__nTqgSG__count",
  "cta": "index-module-scss-module__nTqgSG__cta",
  "illustration": "index-module-scss-module__nTqgSG__illustration",
  "message": "index-module-scss-module__nTqgSG__message",
});
